/**
 * @fileoverview Pylon chat widget service.
 */

const PYLON_APP_ID = 'f8db82c2-b988-49b8-815a-c3c095722397';
const WINDOW_KEY = 'Pylon';
const SETTINGS_KEY = 'pylon';

/**
 * Dynamically loads the Pylon chat widget script.
 * @param userName - The name of the current user.
 * @param userEmail - The email of the current user.
 * @param organizationId - The ID of the current organization.
 * @param emailHash - Optional HMAC hash of the user's email for identity verification.
 */
export function loadPylonScript(
  userName: string,
  userEmail: string,
  organizationId: string,
  emailHash?: string,
) {
  // Check if Pylon is already loaded
  if (window[WINDOW_KEY] && window[SETTINGS_KEY]) {
    return;
  }

  // Initialize Pylon queue
  const pylonQueue = function (...args: any[]) {
    pylonQueue.q.push(args);
  };
  pylonQueue.q = [] as any[];
  window[WINDOW_KEY] = pylonQueue as unknown as (typeof window)[typeof WINDOW_KEY];

  // Load the Pylon script
  const script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', 'true');
  script.setAttribute('src', `https://widget.usepylon.com/widget/${PYLON_APP_ID}`);
  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  // Configure Pylon with user data
  if (window[WINDOW_KEY]) {
    window[SETTINGS_KEY] = {
      chat_settings: {
        app_id: PYLON_APP_ID,
        email: userEmail,
        name: userName,
        account_id: organizationId,
        ...(emailHash && { email_hash: emailHash }),
      },
    };
  }
}

/**
 * Removes the Pylon chat widget script from the DOM.
 */
export function cleanupPylon() {
  if (window[WINDOW_KEY]) {
    delete window[WINDOW_KEY];
  }
  if (window[SETTINGS_KEY]) {
    delete window[SETTINGS_KEY];
  }
}
